import { render } from "./LocalRichTextEditor.vue?vue&type=template&id=187db3b0"
import script from "./LocalRichTextEditor.vue?vue&type=script&lang=js"
export * from "./LocalRichTextEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__